import { applyConfiguredTheme, initializeThemeChangeOnSystemThemeChange } from '@/utils/themes.ts'

export function useThemePlugin(): void {
  applyConfiguredTheme()

  initializeThemeChangeOnSystemThemeChange()
}
